// Module
var code = "<div flex class=\"document-detail\" layout=\"column\"> <abx-detail-header abx-building=\"vm.building\" abx-heading=\"vm.heading\" abx-model=\"vm.document\" abx-model-type=\"document\" abx-subtitle=\"vm.subtitle\" abx-tabs=\"vm.tabs\"> </abx-detail-header> <div ui-view flex layout=\"column\" class=\"scroll-y\"></div> </div> ";
// Exports
module.exports = code;